export default __webpack_public_path__ + "static/media/front-end.000053da.png";